import React, { useEffect, useState } from "react";
import { useLoad } from "../../context";
import ApiServices from "../../services/apiServices";
import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import moment from "moment/moment";
import { toast } from "react-toastify";
import { IoClose } from "react-icons/io5";
import "./index.css";

export default function MeusVouchers() {
  const { setLoad } = useLoad();
  const [meusVouchers, setMeusVouchers] = useState([]);
  const [checkboxListagem, setCheckboxListagem] = useState([]);
  const [checkedItems, setCheckedItems] = useState("");
  const [outroMotivo, setOutroMotivo] = useState("");
  const [lista, setLista] = useState([]);
  const [verMais, setVerMais] = useState(4);
  const [tipoModal, setTipoModal] = useState(null);
  const [idProdutoResgate, setIdProdutoResgate] = useState(null);
  const [filtroStatus, setFiltroStatus] = useState("");
  const [termoPesquisa, setTermoPesquisa] = useState("");

  async function fnMeusVouchers() {
    try {
      setLoad(true);
      let response = await ApiServices.apiPost("produto/meus-vouchers");

      setMeusVouchers(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnCheckboxListagem() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet("produto/motivo-cancelamento");
      setCheckboxListagem(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnCancelar() {
    var objEnvio = {
      produtoResgateId: idProdutoResgate,
      motivoCancelamentoId: checkedItems,
      outroMotivo: outroMotivo != "" ? outroMotivo : null,
    };
    // var objEnvio = { produtoResgateId: idProdutoResgate};
    try {
      setLoad(true);
      let response = await ApiServices.apiPost(
        "produto/resgate/solicitar-cancelamento",
        objEnvio
      );

      if (response.statusCode === 200) {
        toast.success(response.data);
        fnMeusVouchers();
        setTipoModal(0);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnCancelarModal(id) {
    setTipoModal(1);
    setIdProdutoResgate(id);
  }
  async function fnCancelarModalEscola(id) {
    setTipoModal(2);
    setIdProdutoResgate(id);
  }

  useEffect(() => {
    fnMeusVouchers();
    fnCheckboxListagem();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  // Aplicar filtros quando meusVouchers mudar
  useEffect(() => {
    if (meusVouchers.length > 0) {
      aplicarFiltros(termoPesquisa, filtroStatus);
    }
  }, [meusVouchers]); //eslint-disable-line react-hooks/exhaustive-deps

  function fnPesquisar(palavra) {
    setTermoPesquisa(palavra);
    aplicarFiltros(palavra, filtroStatus);
  }

  function fnFiltrarPorStatus(statusId) {
    setFiltroStatus(statusId);
    aplicarFiltros(termoPesquisa, statusId);
  }

  function aplicarFiltros(palavra, statusId) {
    if (!meusVouchers || meusVouchers.length === 0) {
      setLista([]);
      return;
    }

    var li = [];
    meusVouchers.forEach((ele) => {
      // Filtro por texto
      const passaFiltroTexto =
        palavra === "" ||
        ele.descricaoProduto.toUpperCase().includes(palavra.toUpperCase()) ||
        ele.token.includes(palavra);

      // Filtro por status
      let passaFiltroStatus = false;
      if (statusId === "") {
        passaFiltroStatus = true;
      } else if (statusId === "98eaf196-76f5-4c2c-bb6a-0cdef4319a2e") {
        // VOUCHER CANCELADO
        // Apenas vouchers com status cancelado, excluindo os que estão fora do período
        passaFiltroStatus =
          ele.status.produtoResgateStatusId ===
            "98eaf196-76f5-4c2c-bb6a-0cdef4319a2e" &&
          ele.cancelamento !== "fora-prazo-maximo" &&
          ele.cancelamento !== "fora-prazo-minimo" &&
          ele.cancelamento !== "nao-pode-fazer-nada";
      } else if (statusId === "22311786-c42d-42d1-abc3-264b0727d2d6") {
        // CANCELAR VOUCHER
        passaFiltroStatus =
          ele.status.produtoResgateStatusId ===
            "22311786-c42d-42d1-abc3-264b0727d2d6" &&
          ele.cancelamento === "pode-cancelar";
      } else if (statusId === "e6f3436b-abcb-40e4-a4ea-e4b6732add16") {
        // RETIRADO NA LOJA
        passaFiltroStatus =
          ele.status.produtoResgateStatusId ===
          "e6f3436b-abcb-40e4-a4ea-e4b6732add16";
      } else if (statusId === "2897c12a-c0e8-4869-abd4-01a12d7f330b") {
        // AGUARDANDO LEO
        passaFiltroStatus =
          ele.status.produtoResgateStatusId ===
          "2897c12a-c0e8-4869-abd4-01a12d7f330b";
      } else if (statusId === "df73da39-5d5f-46a3-8e98-5b97379febed") {
        // VOUCHER EXPIRADO
        passaFiltroStatus =
          ele.status.produtoResgateStatusId ===
          "df73da39-5d5f-46a3-8e98-5b97379febed";
      } else if (statusId === "fora-periodo") {
        // Fora do período de cancelamento
        // Excluir vouchers que têm dataRetirado (esses são "retirado-em")
        // Excluir vouchers com status cancelado ou expirado (esses têm bolinha vermelha)
        passaFiltroStatus =
          (ele.cancelamento === "fora-prazo-maximo" ||
            ele.cancelamento === "fora-prazo-minimo" ||
            ele.cancelamento === "nao-pode-fazer-nada") &&
          (ele.dataRetirado === null || ele.dataRetirado === undefined) &&
          ele.status.produtoResgateStatusId !==
            "98eaf196-76f5-4c2c-bb6a-0cdef4319a2e" &&
          ele.status.produtoResgateStatusId !==
            "df73da39-5d5f-46a3-8e98-5b97379febed";
      } else if (statusId === "retirado-em") {
        // Retirado Em
        passaFiltroStatus =
          ele.dataRetirado !== null && ele.dataRetirado !== undefined;
      } else {
        // Status padrão por ID
        passaFiltroStatus = ele.status.produtoResgateStatusId === statusId;
      }

      if (passaFiltroTexto && passaFiltroStatus) {
        li.push(ele);
      }
    });
    setLista(li);
    setVerMais(4);
  }

  // Obter lista de status para o dropdown (sempre retorna os 7 itens da legenda)
  function obterStatusUnicos() {
    return [
      {
        id: "df73da39-5d5f-46a3-8e98-5b97379febed",
        nome: "Voucher expirado",
        tipo: "expirado",
      },
      {
        id: "98eaf196-76f5-4c2c-bb6a-0cdef4319a2e",
        nome: "Voucher cancelado",
        tipo: "cancelado",
      },
      {
        id: "22311786-c42d-42d1-abc3-264b0727d2d6",
        nome: "Cancelar voucher",
        tipo: "cancelar",
      },
      {
        id: "e6f3436b-abcb-40e4-a4ea-e4b6732add16",
        nome: "Retirado na loja",
        tipo: "retirado",
      },
      {
        id: "2897c12a-c0e8-4869-abd4-01a12d7f330b",
        nome: "Aguardando Leo",
        tipo: "aguardando",
      },
      {
        id: "fora-periodo",
        nome: "Fora do período de cancelamento",
        tipo: "fora-periodo",
      },
      {
        id: "retirado-em",
        nome: "Retirado em",
        tipo: "retirado-em",
      },
    ];
  }

  const fnChecarCheckBox = (event) => {
    setOutroMotivo("");
    const itemId = event.target.value;
    const isChecked = event.target.checked;
    if (isChecked) {
      setCheckedItems(itemId);
    } else {
      setCheckedItems("");
    }
  };

  useEffect(() => {
    if (tipoModal == 0) {
      setCheckedItems("");
    }
  }, [tipoModal]);

  // Funções auxiliares para determinar o status do voucher
  function getStatusType(e) {
    // Verificar primeiro os status principais
    if (
      e.status.produtoResgateStatusId === "e6f3436b-abcb-40e4-a4ea-e4b6732add16"
    ) {
      return "retirado"; // verde #198754 - RETIRADO NA LOJA
    } else if (
      e.status.produtoResgateStatusId === "2897c12a-c0e8-4869-abd4-01a12d7f330b"
    ) {
      return "aguardando"; // azul #0dcaf0 - AGUARDANDO LEO
    } else if (
      e.status.produtoResgateStatusId === "98eaf196-76f5-4c2c-bb6a-0cdef4319a2e"
    ) {
      // Se tem dataRetirado mas status é cancelado, mostrar "retirado-em"
      if (e.dataRetirado !== null && e.dataRetirado !== undefined) {
        return "retirado-em"; // verde claro #b5e700 - Retirado Em
      }
      return "cancelado"; // vermelho #dc3545 - VOUCHER CANCELADO
    } else if (
      e.status.produtoResgateStatusId === "df73da39-5d5f-46a3-8e98-5b97379febed"
    ) {
      return "expirado"; // vermelho escuro #99111e - VOUCHER EXPIRADO
    } else if (e.cancelamento === "pode-cancelar") {
      return "cancelar"; // amarelo #ffed00 - CANCELAR VOUCHER
    } else if (
      e.cancelamento === "fora-prazo-maximo" ||
      e.cancelamento === "nao-pode-fazer-nada" ||
      e.cancelamento === "fora-prazo-minimo"
    ) {
      // Se tem dataRetirado mas está fora do período, mostrar "retirado-em"
      if (e.dataRetirado !== null && e.dataRetirado !== undefined) {
        return "retirado-em"; // verde claro #b5e700 - Retirado Em
      }
      return "fora-periodo"; // cinza #c5c6b5 - Fora do período de cancelamento
    }

    // Verificar se tem dataRetirado (Retirado Em) como fallback
    if (e.dataRetirado !== null && e.dataRetirado !== undefined) {
      return "retirado-em"; // verde claro #b5e700
    }

    return "cancelar"; // padrão amarelo
  }

  function getStatusText(e) {
    if (
      e.status.produtoResgateStatusId === "e6f3436b-abcb-40e4-a4ea-e4b6732add16"
    ) {
      return "Retirado na loja";
    } else if (
      e.status.produtoResgateStatusId === "2897c12a-c0e8-4869-abd4-01a12d7f330b"
    ) {
      return "Aguardando Leo";
    } else if (
      e.status.produtoResgateStatusId === "98eaf196-76f5-4c2c-bb6a-0cdef4319a2e"
    ) {
      return "Voucher cancelado";
    } else if (
      e.status.produtoResgateStatusId === "df73da39-5d5f-46a3-8e98-5b97379febed"
    ) {
      return "Voucher expirado";
    } else if (e.cancelamento === "pode-cancelar") {
      return "Cancelar Voucher";
    } else if (e.cancelamento === "drible-nao-pode-cancelar") {
      return "Este resgate não permite cancelamento";
    } else if (
      e.cancelamento === "fora-prazo-maximo" ||
      e.cancelamento === "nao-pode-fazer-nada" ||
      e.cancelamento === "fora-prazo-minimo"
    ) {
      return e.dataRetirado
        ? `Retirado em ${moment(e.dataRetirado).format("DD/MM/YYYY")}`
        : "Fora do período de cancelamento";
    }
    return "Cancelar Voucher";
  }

  function getStatusClass(e) {
    const statusType = getStatusType(e);
    if (statusType === "cancelado" || statusType === "expirado") {
      return "status-red";
    } else if (statusType === "cancelar") {
      return "status-yellow";
    } else if (statusType === "retirado") {
      return "status-green";
    } else if (statusType === "aguardando") {
      return "status-blue";
    } else if (statusType === "fora-periodo") {
      return "status-gray";
    }
    return "status-yellow";
  }

  return (
    <>
      <div className="d-flex justify-content-center meus-vouchers-container">
        <div className="container">
          <div className="row my-3">
            <div className="meus-vouchers-header">
              <div className="meus-vouchers-title">
                <h2 className="m-0">Meus Vouchers</h2>
              </div>
              <div className="meus-vouchers-filtros">
                <div className="meus-vouchers-input">
                  <input
                    type="text"
                    placeholder="Digite o número do voucher"
                    onChange={(e) => {
                      fnPesquisar(e.target.value);
                    }}
                    className="form-control"
                  />
                </div>
                <div className="meus-vouchers-select">
                  <select
                    className="form-select"
                    value={filtroStatus}
                    onChange={(e) => {
                      fnFiltrarPorStatus(e.target.value);
                    }}
                  >
                    <option value="">Todos os status</option>
                    {obterStatusUnicos().map((status) => (
                      <option key={status.id} value={status.id}>
                        {status.nome}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          {lista.length === 0 ? (
            <div className="vouchers-empty-message">
              <p>Nenhum voucher encontrado.</p>
            </div>
          ) : (
            <div className="vouchers-grid">
              {lista.map(
                (e, i) =>
                  i < verMais && (
                    <div key={i} className="voucher-card-externo">
                      <div className="voucher-card">
                        {/* Bolinha de status no canto superior esquerdo */}
                        <div
                          className="voucher-status-dot"
                          data-status={getStatusType(e)}
                        ></div>

                        {/* Header do card com efeito de papel rasgado */}
                        <div className="voucher-card-header">
                          <div className="voucher-number">
                            <div className="voucher-number-label">
                              Nº do Voucher
                            </div>
                            <div className="voucher-number-value">
                              {e.token}
                            </div>
                          </div>
                        </div>

                        {/* Conteúdo do card */}
                        <div className="voucher-card-content">
                          <div className="voucher-field">
                            <div className="voucher-field-label">
                              Descrição do produto
                            </div>
                            <div className="voucher-field-value">
                              {e.descricaoProduto}
                            </div>
                          </div>

                          <div className="voucher-field">
                            <div className="voucher-field-label">
                              Data do resgate
                            </div>
                            <div className="voucher-field-value">
                              {moment(e.dataDoResgate).format(
                                "DD/MM/YYYY HH:mm"
                              ) !== "Invalid date"
                                ? moment(e.dataDoResgate).format(
                                    "DD/MM/YYYY HH:mm"
                                  )
                                : "-"}
                            </div>
                          </div>

                          <div className="voucher-field">
                            <div className="voucher-field-label">
                              Cancelamento
                            </div>
                            <div
                              className={`voucher-field-value voucher-status-text ${getStatusClass(
                                e
                              )}`}
                            >
                              {getStatusText(e)}
                            </div>
                          </div>

                          <div className="voucher-field">
                            <div className="voucher-field-label">
                              Motivo cancelamento
                            </div>
                            <div className="voucher-field-value">
                              {e.motivoCancelamento?.nome || "-"}
                            </div>
                          </div>

                          <div className="voucher-field">
                            <div className="voucher-field-label">
                              Data pedido de cancelamento
                            </div>
                            <div className="voucher-field-value">
                              {e.cancelamento === "nao-pode-fazer-nada"
                                ? "-"
                                : moment(e.dataCancelamento).format(
                                    "DD/MM/YYYY HH:mm"
                                  ) !== "Invalid date"
                                ? moment(e.dataCancelamento).format(
                                    "DD/MM/YYYY HH:mm"
                                  )
                                : "-"}
                            </div>
                          </div>

                          <div className="voucher-field">
                            <div className="voucher-field-label">
                              Data retorno Leo
                            </div>
                            <div className="voucher-field-value">
                              {e.cancelamento === "nao-pode-fazer-nada" &&
                              e.dataRetirado
                                ? moment(e.dataRetirado).format(
                                    "DD/MM/YYYY HH:mm"
                                  ) !== "Invalid date"
                                  ? moment(e.dataRetirado).format(
                                      "DD/MM/YYYY HH:mm"
                                    )
                                  : "-"
                                : moment(e.dataCancelamentoConfirmado).format(
                                    "DD/MM/YYYY HH:mm"
                                  ) !== "Invalid date"
                                ? moment(e.dataCancelamentoConfirmado).format(
                                    "DD/MM/YYYY HH:mm"
                                  )
                                : "-"}
                            </div>
                          </div>

                          {/* Botão de cancelar quando aplicável */}
                          {e.cancelamento === "pode-cancelar" && (
                            <button
                              className="btn-cancelar-voucher"
                              onClick={() =>
                                e.token.includes("ESCOLA")
                                  ? fnCancelarModalEscola(e.produtoResgateId)
                                  : fnCancelarModal(e.produtoResgateId)
                              }
                            >
                              CANCELAR VOUCHER
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )
              )}
            </div>
          )}
          <div className="row d-flex justify-content-center">
            <div className="col-md-3">
              {lista.length > verMais && (
                <button
                  onClick={() => {
                    setVerMais(verMais + 4);
                  }}
                  className="btn-ver-mais"
                >
                  VER MAIS
                </button>
              )}
            </div>
          </div>

          <div className="vouchers-legend-container">
            <div className="vouchers-legend-header">
              <h5 className="vouchers-legend-title">
                <b style={{ fontWeight: 700 }}>IMPORTANTE!</b> Resgate seu
                produto em uma loja Leo Madeiras em até 45 dias. Após esse
                período, seu voucher será expirado
              </h5>
              <h5 className="vouchers-legend-subtitle">
                <b style={{ fontWeight: 700 }}>ATENÇÃO:</b> Após a solicitação
                do cancelamento do voucher, o prazo para análise é de até 3 dias
                úteis.
              </h5>
            </div>
            <table className="vouchers-legend-table">
              <tbody>
                <tr style={{ borderColor: "transparent" }}>
                  <td className="vouchers-legend-item">
                    <div className="vouchers-legend-dot-container">
                      <div
                        className="vouchers-legend-dot"
                        style={{ backgroundColor: "#99111e" }}
                      ></div>
                      <span className="vouchers-legend-label">
                        VOUCHER EXPIRADO
                      </span>
                    </div>
                    <div className="vouchers-legend-description">
                      <span>
                        este status corresponde aos vouchers que foram
                        resgatados e, após 45 dias, não foram retirados em loja
                        ou cancelados.
                      </span>
                    </div>
                  </td>
                  <td className="vouchers-legend-item">
                    <div className="vouchers-legend-dot-container">
                      <div
                        className="vouchers-legend-dot"
                        style={{ backgroundColor: "#dc3545" }}
                      ></div>
                      <span className="vouchers-legend-label">
                        VOUCHER CANCELADO
                      </span>
                    </div>
                    <div className="vouchers-legend-description">
                      <span>
                        Voucher gerado foi cancelado. Confira o estorno dos
                        pontos em seu extrato.
                      </span>
                    </div>
                  </td>
                  <td className="vouchers-legend-item">
                    <div className="vouchers-legend-dot-container">
                      <div
                        className="vouchers-legend-dot"
                        style={{ backgroundColor: "#ffed00" }}
                      ></div>
                      <span className="vouchers-legend-label">
                        CANCELAR VOUCHER
                      </span>
                    </div>
                    <div className="vouchers-legend-description">
                      <span>
                        Caso não queira mais o produto resgatado, pode solicitar
                        o cancelamento e aguardar as próximas etapas.
                      </span>
                    </div>
                  </td>
                  <td className="vouchers-legend-item">
                    <div className="vouchers-legend-dot-container">
                      <div
                        className="vouchers-legend-dot"
                        style={{ backgroundColor: "#198754" }}
                      ></div>
                      <span className="vouchers-legend-label">
                        RETIRADO NA LOJA
                      </span>
                    </div>
                    <div className="vouchers-legend-description">
                      <span>
                        O produto consta como resgatado em uma das lojas Leo
                        Madeiras. Consulte seu vendedor.
                      </span>
                    </div>
                  </td>
                  <td className="vouchers-legend-item">
                    <div className="vouchers-legend-dot-container">
                      <div
                        className="vouchers-legend-dot"
                        style={{ backgroundColor: "#0dcaf0" }}
                      ></div>
                      <span className="vouchers-legend-label">
                        AGUARDANDO LEO
                      </span>
                    </div>
                    <div className="vouchers-legend-description">
                      <span>
                        Pedido de cancelamento enviado para análise do time da
                        Leo Madeiras.
                      </span>
                    </div>
                  </td>
                  <td className="vouchers-legend-item">
                    <div className="vouchers-legend-dot-container">
                      <div
                        className="vouchers-legend-dot"
                        style={{ backgroundColor: "#c5c6b5" }}
                      ></div>
                      <span className="vouchers-legend-label">
                        Fora do período de cancelamento
                      </span>
                    </div>
                    <div className="vouchers-legend-description">
                      <span>
                        Após 7 dias do resgate do voucher, não será possível a
                        solicitação de cancelamento.
                      </span>
                    </div>
                  </td>
                  <td className="vouchers-legend-item">
                    <div className="vouchers-legend-dot-container">
                      <div
                        className="vouchers-legend-dot"
                        style={{ backgroundColor: "#b5e700" }}
                      ></div>
                      <span className="vouchers-legend-label">Retirado Em</span>
                    </div>
                    <div className="vouchers-legend-description">
                      <span>
                        Mostra a data em que o produto resgatado foi retirado na
                        loja Leo Madeiras.
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {tipoModal == 1 && (
            <div className="divModal">
              <div className="conteudoModal">
                <div className="tituloModal" style={{ fontWeight: 700 }}>
                  <p>MOTIVO DO CANCELAMENTO DO VOUCHER</p>
                  <IoClose
                    className="iconeModal"
                    onClick={() => {
                      setTipoModal(0);
                    }}
                  />
                </div>

                {checkboxListagem.map((item) => (
                  <FormControlLabel
                    key={item.motivoCancelamentoId}
                    control={
                      <Checkbox
                        checked={checkedItems.includes(
                          item.motivoCancelamentoId
                        )}
                        onChange={fnChecarCheckBox}
                        value={item.motivoCancelamentoId}
                        color="primary"
                        sx={{
                          "&.Mui-checked": {
                            color: "#ffed00",
                          },
                        }}
                      />
                    }
                    label={item.nome}
                  />
                ))}

                {checkedItems == "685bad04-668b-4f0d-97af-682f812193b7" && (
                  <TextField
                    label="Outro motivo"
                    className="mt-3"
                    value={outroMotivo}
                    onChange={(e) => {
                      setOutroMotivo(e.target.value);
                    }}
                    inputProps={{ maxLength: 50 }}
                    multiline
                    rows={3}
                    variant="outlined"
                  />
                )}
                <div className="mt-3 d-flex justify-content-center">
                  <button
                    className="btn btn-sm btn-warning"
                    style={{ maxWidth: "300px" }}
                    onClick={() => fnCancelar()}
                  >
                    ENVIAR
                  </button>
                </div>
              </div>
            </div>
          )}

          {tipoModal == 2 && (
            <div className="divModal">
              <div className="conteudoModal">
                <div className="tituloModal" style={{ fontWeight: 700 }}>
                  <p>MOTIVO DO CANCELAMENTO DO VOUCHER</p>
                  <IoClose
                    className="iconeModal"
                    onClick={() => {
                      setTipoModal(0);
                    }}
                  />
                </div>

                {checkboxListagem.map(
                  (item) =>
                    item.motivoCancelamentoId !=
                      "b7d83b57-84e3-40b9-b934-a003cdf71af6" && (
                      <FormControlLabel
                        key={item.motivoCancelamentoId}
                        control={
                          <Checkbox
                            checked={checkedItems.includes(
                              item.motivoCancelamentoId
                            )}
                            onChange={fnChecarCheckBox}
                            value={item.motivoCancelamentoId}
                            color="primary"
                            sx={{
                              "&.Mui-checked": {
                                color: "#ffed00",
                              },
                            }}
                          />
                        }
                        label={item.nome}
                      />
                    )
                )}

                {checkedItems == "685bad04-668b-4f0d-97af-682f812193b7" && (
                  <TextField
                    label="Outro motivo"
                    className="mt-3"
                    value={outroMotivo}
                    onChange={(e) => {
                      setOutroMotivo(e.target.value);
                    }}
                    inputProps={{ maxLength: 50 }}
                    multiline
                    rows={3}
                    variant="outlined"
                  />
                )}
                <div className="mt-3 d-flex justify-content-center">
                  <button
                    className="btn btn-sm btn-warning"
                    style={{ maxWidth: "300px" }}
                    onClick={() => fnCancelar()}
                  >
                    ENVIAR
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
